import React, { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { ShieldAlert } from "lucide-react";

const KEY = "ss_disclaimer_ack_v1";

export default function DisclaimerModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setOpen(true);
  }, []);

  const agree = () => {
    localStorage.setItem(KEY, "1");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="disclaimer-modal" role="dialog" aria-modal="true">
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" />
      <div className="relative w-full max-w-lg rounded-2xl border border-amber-500/30 bg-card p-6 shadow-2xl ss-fade-up">
        <div className="flex flex-col items-center text-center gap-4 py-2">
          <div className="h-14 w-14 rounded-2xl bg-amber-500/15 border border-amber-500/30 flex items-center justify-center">
            <ShieldAlert className="h-7 w-7 text-amber-500" />
          </div>
          <h2 className="text-2xl font-bold font-heading">For Education Only</h2>
          <p className="text-muted-foreground leading-relaxed">
            Aqvoro AI is a <strong className="text-foreground">learning tool</strong>. The scores, rankings,
            "picks", and paper-trading features are for educational purposes to help you understand technical
            signals. This is <strong className="text-foreground">not financial advice</strong> and never
            involves real money. Nothing here is a recommendation to buy or sell any security.
          </p>
          <p className="text-xs text-muted-foreground">
            Always do your own research and consult a licensed advisor before investing.
          </p>
          <Button
            data-testid="disclaimer-agree-btn"
            onClick={agree}
            className="w-full mt-2 bg-primary hover:bg-primary/90 text-primary-foreground font-semibold"
          >
            I Understand &amp; Agree
          </Button>
        </div>
      </div>
    </div>
  );
}
